import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "./lib/SmoothScroll";
import { AuthProvider } from "./lib/auth";
import Navbar from "./components/site/Navbar";
import Footer from "./components/site/Footer";
import GrainOverlay from "./components/site/GrainOverlay";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import Studio from "./pages/Studio";
import Journal from "./pages/Journal";
import JournalPost from "./pages/JournalPost";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import Partners from "./pages/Partners";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function AppShell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/studio" element={<Studio />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/journal/:slug" element={<JournalPost />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <div className="App bg-[var(--bg)] text-[var(--ink)] min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <SmoothScroll>
            <GrainOverlay />
            <ScrollToTop />
            <AppShell />
            <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "var(--bg)", border: "1px solid #2A2A2A", color: "#E8E8E8", fontFamily: "'Cormorant Garamond', serif" } }} />
          </SmoothScroll>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
